import { createFileRoute, notFound } from "@tanstack/react-router";

import { CareersPage } from "@/components/marketing/careers-page";
import { MARKETING_FLAGS } from "@/lib/marketing-flags";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/careers")({
  // A flagged-off page answers 404. It used to redirect home, which Google
  // treats as a soft 404, and robots.txt hid even that.
  beforeLoad: () => {
    if (!MARKETING_FLAGS.careers) {
      throw notFound();
    }
  },
  head: () => pageHead("careers"),
  component: CareersPage,
});
